import priceApi from "../../../api/dtl/price";

const state = {
  list: []
};

const getters = {};

const mutations = {};

const actions = {
  // 获取列表
  getLst({ state }, { params, callback }) {
    console.log(state);
    priceApi.getLstApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取列表
  getLst2({ state }, { params, callback }) {
    console.log(state);
    priceApi.getLst2Api({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/dtl/price.js